module.exports = __webpack_public_path__ + "static/media/banner-mobile-janeiro-2025.3c4a2763.png";